import { keyframes } from 'styled-components'

export const zoomIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.6);
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
`

export const zoomOut = keyframes`
  from {
    transform: scale(1);
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale(0.7);
  }
`
